import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCallCenterHomePageContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledCallCenterWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: '3rem',
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
  },
}));

export const StyledCallCenterButtonsContainer = styled(Box)(({ theme }) => ({
  width: '35%',
  paddingRight: '2rem',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    paddingRight: 0,
    marginBottom: '3rem',
  },
}));

export const StyledCallCenterCameraContainer = styled(Box)(({ theme }) => ({
  width: '65%',
  paddingLeft: '2rem',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    paddingLeft: 0,
  },
}));

export const StyledCallCenterNote = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.ccNote,
  padding: '1rem 3rem',
  width: '100%',
  fontSize: '1.8rem',
}));

export const StyledCallCenterTableContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.background,
  margin: `2rem 0 5rem 0`,
}));
